import React, {
  useCallback,
  useContext,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import RadioGroupContext from '../context'

import Styles from './styles.module.sass'


export default function RadioButton({ label, value, className, disabled }) {
  const {
    groupDisabled,
    handleChange,
    name,
    selectedValue,
  } = useContext(RadioGroupContext)

  const checked = ( selectedValue === value )
  const isDisabled = ( groupDisabled || disabled )

  const onChange = useCallback((e) => {
    e.stopPropagation()

    const { target } = e

    handleChange({
      checked: target.checked,
      value: target.value,
    })
  }, [handleChange])

  const rootClassName = classnames(Styles.root, className, {
    [Styles.disabled]: isDisabled,
  })

  const radioClassName = classnames(Styles.radio, {
    [Styles.checked]: checked,
    [Styles.disabled]: isDisabled,
  })

  return (
    <label className={ rootClassName }>
      <input
        checked={ checked }
        disabled={ isDisabled }
        className={ Styles.input }
        name={ name }
        onChange={ onChange }
        type="radio"
        value={ value }
      />
      <div className={ radioClassName }>
        <span className={ Styles.radio__inner } />
      </div>
      { label }
    </label>
  )
}

RadioButton.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
}
